import { render, staticRenderFns } from "./SubprocessDetailDialog.vue?vue&type=template&id=5fca29c7&scoped=true&"
import script from "./SubprocessDetailDialog.vue?vue&type=script&lang=js&"
export * from "./SubprocessDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./SubprocessDetailDialog.vue?vue&type=style&index=0&id=5fca29c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fca29c7",
  null
  
)

export default component.exports